let DOMParserConstructor;
if (typeof window !== "undefined" && typeof window.DOMParser !== "undefined") {
    // Browser environment
    DOMParserConstructor = window.DOMParser;
}
else {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { JSDOM } = require("jsdom");
    DOMParserConstructor = JSDOM; // JSDOM's constructor can be used similarly for parsing
}
export function htmlDecode(input) {
    if (!input) {
        return undefined;
    }
    let doc;
    if (typeof window !== "undefined" && typeof window.DOMParser !== "undefined") {
        // Browser environment
        doc = new DOMParserConstructor().parseFromString("<div>" + input + "</div>", "text/html");
    }
    else {
        // Node.js environment using jsdom
        // JSDOM takes the HTML string directly and provides a window object
        doc = new DOMParserConstructor(`<div>${input}</div>`, { contentType: "text/html" }).window.document;
    }
    return doc.body.textContent;
}
//# sourceMappingURL=htmlDecode.js.map